import styled from 'styled-components';

export const ResetContainer = styled.div`
height: 100vh;
min-height: 600px;
background-color: #F0FFE6;
`;

export const ResetWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
max-width: 1100px;
margin-left: auto;
margin-right: auto;
padding: 0 25px 0 25px;
justify-content: center;
`;

export const ResetForm = styled.form`
display: flex;
flex-direction: column;
`;

export const InputHolder = styled.div`
width: 100%;
max-width: 600px;
margin-left: auto;
margin-right: auto;
`;

export const ResetInput = styled.input`
border: none;
border-bottom: 2px solid #D3D3D3;
height: 40px;
width: 100%;
padding-left: 5px;
margin-bottom: 20px;
transition: all 0.2s ease-in-out;
background: #F0FFE6;

::placeholder {
font-size: 16px;
}

&:focus {
    outline: none;
    border-bottom: 2px solid #33682c;
}
`;

export const ResetButton = styled.button`
width: 100%;
max-width: 200px;
height: 50px;
border-radius: 5px;
border: none;
background: rgb(51,104,44);
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
font-weight: bold;
margin-top: 25px;
margin-left: auto;
margin-right: auto;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}

&:disabled {
  color: #fff;
  background: #808080;

  &:hover {
    cursor: not-allowed;
    transform: scale(1);
    background: #808080;
}}
`;

export const ResetHeader = styled.h1`
font-size: 28px;
color: #33682c;
margin-bottom: 50px;
text-align: center;
`;

export const ErrorText = styled.p`
font-size: 14px;
width: 100%;
color: #fff;
text-align: left;
margin-top: 10px;
border-radius: 10px;
padding: 10px;
background-color: #619657;
margin-bottom: 20px;
`;

export const FeedbackText = styled.p`
font-size: 14px;
color: #000;
text-align: center;
margin-top: 25px;
`;

export const SuccessMessage = styled.p`
font-size: 24px;
color: #000;
text-align: center;
margin-bottom: 10px;

@media screen and (max-width: 768px){
    font-size: 20px;
}

@media screen and (max-width: 480px){
    font-size: 18px;
}
`;
